<template>
  <v-radio-group
    v-model="lang"
    :rules="rules"
    row
    style="width: 100%"
    class="mt-0"
    hide-details="auto"
  >
    <v-radio
      class="col col-4 pa-0 pr-4 mr-0"
      color="primary"
      v-for="(val, key) in languages"
      :value="val.id"
      :label="val.name"
      :key="key"
    >
    </v-radio>
  </v-radio-group>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    rules: {},
    value: {},
    items: {type: Array, default: () => []},
  },
  data() {
    return {
      lang: null,
      langDefault: [
        { id: 30, name: "English" },
        { id: 37, name: "French" },
        { id: 60, name: "Japanese" },
      ],
    };
  },
  computed: {
    languages() {
      return this.items || this.langDefault;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          if (val.id) {
            this.lang = val.id;
          } else {
            this.lang = val;
          }
        }
      },
    },
    lang(val) {
      this.$emit("input", val);
    },
  },
};
</script>